<app-header-four></app-header-four>
<!-- Banner Start -->
<div class="banner banner-1 banner-4 light-banner">

    <div class="banner-item">
      <div class="banner-inner bg-cover bg-center dark-overlay dark-overlay-2" style="background-image: url('assets/img/banner/7.jpg')">
        <div class="container">
          <img src="assets/img/misc/1.png" alt="img">
          <h1 class="title">Modernizing The Traditional Italian Pizza</h1>
          <p class="subtitle">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry
          </p>
          <a href="#" class="btn-custom primary">View Menu</a>
        </div>
        <div class="banner-bottom-img">
          <img src="assets/img/veg/2.png" alt="veg">
          <img src="assets/img/prods/3.png" alt="pizza">
          <img src="assets/img/veg/12.png" alt="veg">
        </div>
      </div>
    </div>

  </div>
  <!-- Banner End -->

  <!-- About us start -->
  <div class="section">
    <div class="container">
      <div class="row align-items-center">

        <div class="col-lg-6 mb-lg-30 ct-single-img-wrapper">
          <img src="assets/img/about.jpg" alt="img">
          <div class="ct-dots"></div>
        </div>
        <div class="col-lg-6">
          <div class="section-title-wrap mr-lg-30">
            <h5 class="custom-primary">Sir Slice's Heritage</h5>
            <h2 class="title">Serving Pizzas By The Slice Since 1987</h2>
            <p class="subtitle">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
            <p class="subtitle">
              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
            </p>
            <div class="signature">
              <img src="assets/img/signature.png" alt="signature">
            </div>
            <a routerLink='/menu-v1' class="btn-custom">Check our Menu</a>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- About us End -->

  <!-- Menu Start -->
  <div class="section section-padding pt-0">
    <div class="container">

      <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">Pizza Menu</h5>
        <h2 class="title">Explore Our Menu</h2>
        <p class="subtitle">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
        </p>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="ct-mini-menu-item">
            <div class="ct-mini-menu-top">
              <h5>Pepperoni Pizza</h5>
              <div class="ct-mini-menu-dots"></div>
              <span class="custom-primary">14.99$</span>
            </div>
            <div class="ct-mini-menu-bottom">
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="ct-mini-menu-item">
            <div class="ct-mini-menu-top">
              <h5>Four Cheese</h5>
              <div class="ct-mini-menu-dots"></div>
              <span class="custom-primary">13.99$</span>
            </div>
            <div class="ct-mini-menu-bottom">
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="ct-mini-menu-item">
            <div class="ct-mini-menu-top">
              <h5>Vegetarian</h5>
              <div class="ct-mini-menu-dots"></div>
              <span class="custom-primary">9.99$</span>
            </div>
            <div class="ct-mini-menu-bottom">
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="ct-mini-menu-item">
            <div class="ct-mini-menu-top">
              <h5>Barbeque Chicken</h5>
              <div class="ct-mini-menu-dots"></div>
              <span class="custom-primary">13.99$</span>
            </div>
            <div class="ct-mini-menu-bottom">
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="ct-mini-menu-item">
            <div class="ct-mini-menu-top">
              <h5>Ham & Cheese</h5>
              <div class="ct-mini-menu-dots"></div>
              <span class="custom-primary">11.99$</span>
            </div>
            <div class="ct-mini-menu-bottom">
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="ct-mini-menu-item">
            <div class="ct-mini-menu-top">
              <h5>Specialty Pizza</h5>
              <div class="ct-mini-menu-dots"></div>
              <span class="custom-primary">10.99$</span>
            </div>
            <div class="ct-mini-menu-bottom">
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been.</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- Menu End -->

  <!-- Gallery Start -->
  <div class="section pt-0">
    <div class="gallery-section">
      <div class="row no-gutters">
        <div class="col-xl-6 col-lg-3 col-md-3 col-6 p-0">
          <a href="assets/img/ig/1.jpg" class="gallery-thumb">
            <img src="assets/img/ig/1.jpg" alt="ig">
          </a>
        </div>
        <div class="col-xl-6 col-lg-3 col-md-3 col-6 p-0">
          <a href="assets/img/ig/2.jpg" class="gallery-thumb">
            <img src="assets/img/ig/2.jpg" alt="ig">
          </a>
        </div>
        <div class="col-xl-6 col-lg-3 col-md-3 col-6 p-0">
          <a href="assets/img/ig/3.jpg" class="gallery-thumb">
            <img src="assets/img/ig/3.jpg" alt="ig">
          </a>
        </div>
        <div class="col-xl-6 col-lg-3 col-md-3 col-6 p-0">
          <a href="assets/img/ig/4.jpg" class="gallery-thumb">
            <img src="assets/img/ig/4.jpg" alt="ig">
          </a>
        </div>
      </div>
      <div class="gallery-bg bg-parallax dark-overlay dark-overlay-2 bg-cover" style="background-image: url('assets/img/subheader.jpg')">
        <div class="section-title-wrap text-center">
          <h5 class="custom-primary">A Community</h5>
          <h2 class="title text-white">Stories of Passion</h2>
          <p class="subtitle text-white">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been.
          </p>
          <a routerLink='/blog-grid' class="btn-custom shadow-none">Read Stories</a>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col-xl-6 col-lg-3 col-md-3 col-6 p-0">
          <a href="assets/img/ig/5.jpg" class="gallery-thumb">
            <img src="assets/img/ig/5.jpg" alt="ig">
          </a>
        </div>
        <div class="col-xl-6 col-lg-3 col-md-3 col-6 p-0">
          <a href="assets/img/ig/6.jpg" class="gallery-thumb">
            <img src="assets/img/ig/6.jpg" alt="ig">
          </a>
        </div>
        <div class="col-xl-6 col-lg-3 col-md-3 col-6 p-0">
          <a href="assets/img/ig/7.jpg" class="gallery-thumb">
            <img src="assets/img/ig/7.jpg" alt="ig">
          </a>
        </div>
        <div class="col-xl-6 col-lg-3 col-md-3 col-6 p-0">
          <a href="assets/img/ig/8.jpg" class="gallery-thumb">
            <img src="assets/img/ig/8.jpg" alt="ig">
          </a>
        </div>
      </div>
    </div>

  </div>
  <!-- Gallery End -->

  <!-- Blog Start -->
  <div class="section section-padding pt-0">
    <div class="container">

      <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">Latest News</h5>
        <h2 class="title">From Our Blog</h2>
        <p class="subtitle">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
        </p>
      </div>

      <div class="row">
        <!-- Post Start -->
        <div class="col-lg-4">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>Our all new chicken pizza now available</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>January 22, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/6.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->

        <!-- Post Start -->
        <div class="col-lg-4">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>Changing the way thin crusts are made</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>January 24, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/2.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->

        <!-- Post Start -->
        <div class="col-lg-4">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>New cheese rolls are now available in all branches</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>January 27, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/3.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->
      </div>

    </div>
  </div>
  <!-- Blog End -->

  <!-- Map Start -->
  <div class="section-map pb-0">
    <div class="ct-contact-map-wrapper">
      <div id="contactPageMap" class="ct-contact-map map" leaflet
      [leafletOptions]="options"
      [leafletLayersControl]="layersControl"></div>
    </div>
  </div>
  <!-- Map End -->
<app-footer></app-footer>